import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const projectSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '#project-hero',
    content:
      'O cabeçalho do projeto exibe o nome, status atual, responsável, prazo e progresso geral. Clique no ícone de edição para alterar qualquer informação básica.',
  },
  {
    selector: '#project-milestones',
    content:
      'Os marcos do projeto mostram as entregas principais com seus prazos. Marcos atrasados aparecem destacados em vermelho.',
  },
  {
    selector: '#project-views',
    content:
      'Alterne entre as visualizações do projeto: detalhe padrão, Kanban (quadro de tarefas) ou Gantt (linha do tempo). Cada visão oferece uma perspectiva diferente do andamento.',
  },
  {
    selector: '[data-tour="project-tab-actions"]',
    content:
      'A aba "Ações" lista as tarefas prioritárias da semana com responsável, prazo e status. Adicione e acompanhe as ações do time aqui.',
  },
  {
    selector: '[data-tour="project-tab-tasks"]',
    content:
      'A aba "Tarefas" mostra todas as tarefas do projeto. Filtre por status, responsável ou data para ter uma visão completa do trabalho em andamento.',
  },
  {
    selector: '[data-tour="tasks-group-by-toggle"]',
    content:
      'Agrupe as atividades por grupo de trabalho para visualizar o progresso de cada frente separadamente. Cada grupo pode ser expandido ou colapsado individualmente.',
  },
  {
    selector: '[data-tour="tasks-group-by-milestone"]',
    content:
      'Agrupe as atividades por marco para acompanhar quais tarefas pertencem a cada etapa do projeto. Tarefas sem marco associado aparecem no grupo "Sem marco".',
  },
  {
    selector: '[data-tour="project-tab-risks"]',
    content:
      'A aba "Riscos" centraliza todos os riscos identificados com probabilidade, impacto e plano de mitigação. Riscos críticos são destacados automaticamente.',
  },
  {
    selector: '[data-tour="project-tab-costs"]',
    content:
      'A aba "Financeiro" exibe o orçamento aprovado, custos realizados e previsão de conclusão. O semáforo indica se o projeto está dentro do orçamento.',
  },
  {
    selector: '[data-tour="ai-report-btn"]',
    content:
      'Gere um Relatório Executivo completo com IA! A análise usa Azure OpenAI (gpt-4.1) para interpretar tarefas, riscos, orçamento e cronograma e produz um relatório em PT-BR com gráficos e insights prontos para exportar em PDF.',
  },
];

export const projectKanbanSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="kanban-board"]',
    content:
      'O quadro Kanban organiza as tarefas em colunas por status. Arraste e solte os cards para mover tarefas entre colunas.',
  },
  {
    selector: '[data-tour="kanban-add-task"]',
    content: 'Clique aqui para adicionar uma nova tarefa diretamente no quadro Kanban.',
  },
];

export const projectGanttSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="gantt-timeline"]',
    content:
      'O Gantt exibe todas as tarefas em uma linha do tempo. Barras azuis são tarefas dentro do prazo; barras vermelhas indicam atraso.',
  },
  {
    selector: '[data-tour="gantt-add-task"]',
    content: 'Adicione uma nova tarefa ao cronograma clicando neste botão.',
  },
];
